<template lang="pug">
  div
    v-row(v-if="$route.name === 'CourseEnrollment'")
      v-col(cols=12 md=10 lg=8 xl=7)
        .caption Курс
        .text-h6 {{ course.title }}
        .d-flex.align-center.mt-8
          h1(class="d-flex").text-body-2
            strong Список наборов
            span.grey--text.ml-2 {{enrollmentList.length}}
          v-spacer
          v-btn(
            v-if="$user.isOrganization || isCurator"
            depressed
            text
            color="primary"
            :to="{ name: 'EnrollmentCreate', params: { id: courseId } }"
          )
            | Добавить набор
            v-icon(right) mdi-account-multiple-plus
        .mt-5
        template(
          v-for="enrollment in enrollmentList"
        )
          v-list-item.sdo-shadow.mb-6.sdo-radius.py-5.pl-6(
            :key="enrollment.id"
            :to=`{
              name: 'CourseEnrollmentRecords',
              params: { enrollmentId: enrollment.id, id: courseId }
            }`
          )
            v-list-item-avatar.mr-8: strong {{enrollment.code}}
            v-list-item-content.pa-0
              //- v-list-item.pt-2.px-6
              //-   v-list-item-title: strong {{enrollment.code}}
              //-   v-list-item-action.ma-0
              //-     v-menu
              //-       template(#activator="{ on }")
              //-         v-btn(icon v-on="on"): v-icon mdi-menu
              //-       v-list.secondary(dark)
              //-         v-list-item(@click="openEditDialog(enrollment)")
              //-           v-list-item-icon.mr-4: v-icon mdi-pencil
              //-           v-list-item-title Редактировать
              //-         v-list-item(@click="openDeleteDialog(enrollment.id)")
              //-           v-list-item-icon.mr-4: v-icon(color="error") mdi-delete
              //-           v-list-item-title.error--text Удалить

              v-list-item.px-0
                v-list-item(style="min-height: 0 !important")
                  v-list-item-icon.ma-0.mr-3(
                    v-if="new Date(enrollment.period_end) < new Date()"
                  ): tooltip-wrap(text="Завершен"): v-icon(
                      color="success"
                    ) mdi-check-circle-outline

                  v-list-item-icon.ma-0.mr-3(
                    v-else-if="new Date(enrollment.period_start) < new Date()"
                  ): tooltip-wrap(text="В процессе"): v-icon(
                      color="warning"
                    ) mdi-clock-outline

                  v-list-item-icon.pa-0.mr-3(
                    v-else
                  ): tooltip-wrap(text="Набор еще не начался"): v-icon(
                      color="secondary" size="20"
                    ) mdi-clock-outline

                  v-list-item-content.py-0
                    span.caption: strong Набор
                    .text-body-2: .grey--text.text--darken-2
                      span c {{ enrollment.period_start | dp('d MMMM') }}
                      span  по {{ enrollment.period_end | dp('d MMMM') }}

                v-list-item(style="min-height: 0 !important")

                  v-list-item-icon.ma-0.mr-3(
                    v-if="new Date(enrollment.end_learning) < new Date()"
                  ): tooltip-wrap(text="Завершено"): v-icon(color="success") mdi-check

                  v-list-item-icon.ma-0.mr-3(
                    v-else-if="new Date(enrollment.start_learning) < new Date()"
                  ): tooltip-wrap(text="В процессе"): v-icon(
                      color="warning"
                    ) mdi-clock-outline

                  v-list-item-icon.ma-0.mr-3(
                    v-else
                  ): tooltip-wrap(text="Обучение еще не началось"): v-icon(
                    color="secondary"
                  ) mdi-clock-outline

                  v-list-item-content.py-0
                    span.caption: strong Обучение
                    .text-body-2: .grey--text.text--darken-2
                      span c {{ enrollment.start_learning | dp('d MMMM') }}
                      span  по {{ enrollment.end_learning | dp('d MMMM') }}
              //- v-row.px-4(no-gutters)
              //-   v-col
              //-     v-list-item.grey.lighten-4.tile.pl-5(
              //-       :to=`{
              //-           name: 'CourseEnrollmentRecords',
              //-           params: { enrollmentId: enrollment.id, id: courseId }
              //-       }`
              //-     )
              //-       v-icon.mr-4 mdi-page-layout-body
              //-       v-list-item-title: strong Набор
              //-   v-col
              //-     v-list-item.grey.lighten-4.tile.pl-5(
              //-       :to=`{
              //-         name: 'CourseGroupList',
              //-         params: { id: course.id, enrollmentId: enrollment.id }
              //-       }`
              //-     )
              //-       v-icon.mr-4 mdi-page-layout-body
              //-       v-list-item-title: strong Группы
              //- .caption Обучающихся
              //- .text-body-2 {{ enrollment.count_users }} из {{ enrollment.number_place}}

          //- enrollment-element(
          //-   v-for="enrollment in enrollmentList"
          //-   :key="enrollment.id"
          //-   :enrollment="enrollment"
          //-   :course="course"
          //-   @edit="editEnrollment(enrollment)"
          //-   @delete="openDeleteDialog(enrollment)"
          //- ).sdo-card.mb-10
      enrollment-dialog(
        v-model="showDialog"
        :course-id="courseId"
        :init-data="selectedEnrollment"
        @update="init"
      )
    router-view(v-else-if="!$loader.isLoading")
</template>

<script>
import EnrollmentDialog from '@/modules/CourseManagement/pages/CourseEnrollmentList/CourseEnrollmentListCreateDialog.vue';
import EnrollmentElement from '@/modules/CourseManagement/components/Enrollment/EnrollmentElement.vue';
import CourseEnrollmentService from '@/services/API/CourseEnrollmentService';

export default {
  name: 'CourseEnrollment',
  components: {
    EnrollmentElement,
    EnrollmentDialog,
  },
  data: () => ({
    showDialog: false,
    selectedEnrollment: null,
    enrollmentList: [],
    isCurator: false,
    course: null,
    headers: [
      { text: 'Начало периода', value: 'period_start' },
      { text: 'Конец периода', value: 'period_end' },
      { text: 'Начало обучения', value: 'start_learning' },
      { text: 'Конец обучения', value: 'end_learning' },
      { text: 'Количество мест', value: 'number_place' },
      { text: 'Действия', value: 'actions' },
    ],
    loading: true,

  }),
  computed: {
    courseId() {
      return +this.$route.params.id;
    },
    isCurator() {
      return this.curatorIds.includes(this.$user.data.id);
    },
  },
  watch: {
    '$route.name': function () {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    openDeleteDialog(id) {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите удаление',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await CourseEnrollmentService.deleteEnrollment(id).then(() => {
            this.$modals.close();
            this.init();
          });
        },
      });
    },
    openEditDialog(enrollment) {
      this.selectedEnrollment = enrollment;
      this.showDialog = true;
    },
    async init() {
      this.$loader.start({ target: true });
      await this.fetchCourse();
      await this.getEnrollmentList();
      if (!this.$user.isOrganization) await this.getCurators();
      this.$loader.stop();
    },
    async getCurators() {
      const { data } = await this.$api.courses.isCurator(this.course.id);
      this.isCurator = data.data.is_curator;
    },
    async fetchCourse() {
      const { item } = await this.$api.courses.show(this.courseId);
      this.course = item;
    },
    getEnrollmentList() {
      return this.$rHandler(
        CourseEnrollmentService.getEnrollmentList(this.courseId, { params: { expand: 'telegram' } }),
        (r) => {
          this.enrollmentList = r.data.data;
        },
      );
    },

    onEnrollmentUpdate(item) {
      this.enrollmentList = this.enrollmentList.filter((e) => e.id !== item.id);
      this.enrollmentList.push(item);
    },
  },
};
</script>
<style lang="scss" scoped>
  .tile {
    border-radius: 0 !important;
  }
  .title {
    border-radius: 0 !important;
    line-height: 1.5rem !important;
  }
</style>
